<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[$t('menu.deliveryRequisition'), $t('text.create')]"
      ></breadcrumb>
      <div class="container">
        <el-form
          ref="deliveryRequisitionObjForm"
          :model="deliveryRequisitionObj"
          size="small"
          label-width="110px"
        >
          <div class="pd20">
            <fieldset class="mgb15">
              <legend>{{ $t("text.baseInfo") }}</legend>
              <el-row>
                <el-col :span="7">
                  <el-form-item
                    :label="$t('deliveryRequisition.serialNo')"
                    :prop="'serialNo'"
                    :rules="[
                      {
                        required: true,
                        validator: validateSerialNo,
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      size="small"
                      v-model.trim="deliveryRequisitionObj.serialNo"
                      :placeholder="$t('prompt.alphabetNumberLine')"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item
                    :label="$t('deliveryRequisition.handOverAt')"
                    :prop="'handOverAt'"
                    :rules="[
                      {
                        required: true,
                        message: $t('deliveryRequisition.handOverAt'),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-date-picker
                      size="small"
                      v-model="deliveryRequisitionObj.handOverAt"
                      type="date"
                      style="width: 100%"
                      :picker-options="pickerTodayAfterTime"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </fieldset>
            <fieldset class="mgb15">
              <legend>{{ $t("text.remark") }}</legend>
              <el-input
                size="small"
                v-model.trim="deliveryRequisitionObj.remark"
                type="textarea"
                :rows="2"
              ></el-input>
            </fieldset>
            <fieldset class="mgb15">
              <legend>{{ $t("menu.bargains") }}</legend>
              <!-- <div>
                <narrow :narrows="narrows" @narrowSelect="narrowSelect" />
              </div> -->
              <div class="center mgb15">
                <el-radio-group
                  v-model="radioType"
                  size="small"
                  @change="selectRadioType"
                >
                  <el-radio-button label="finished"
                    >已完成状态订单</el-radio-button
                  >
                  <el-radio-button label="all">全部已选择订单</el-radio-button>
                </el-radio-group>
              </div>
              <vxe-table
                :data="computeBargains"
                :merge-cells="mergeCells"
                id="bargainsTable"
                row-id="id"
                ref="recordsTable"
                class="recordsTable"
                :row-class-name="calculateBgColor"
                size="mini"
                resizable
                round
                auto-resize
                highlight-hover-row
                :scroll-y="{ enabled: false }"
              >
                <vxe-table-column
                  field="images"
                  :title="$t('product.images')"
                  width="80"
                >
                  <template v-slot="{ row }">
                    <span v-if="!row.isBargain">
                      <thumbnail :images="row.images"></thumbnail>
                    </span>
                    <div v-else>
                      <span class="float-left">
                        <span class="mgr5">{{ row.serialNo }}</span>
                        <span class="font10 mgr5"
                          >{{ $t("bargain.productQty") }}:{{
                            row.productQty
                          }}</span
                        >
                        <span
                          v-if="Permit.canActions('globalSalePrice')"
                          class="font10"
                        >
                          <span class="mgr5">
                            {{ $t("bargain.amount") }}:
                            <currency :code="row.currency"></currency>
                            {{ row.amount }}
                          </span>
                          <span v-if="row.settleType == 'later'">{{
                            $t("settleTypes.later")
                          }}</span>
                          <span v-if="row.settleType == 'now'">
                            <span class="mgr5">
                              {{ $t("bargain.receive") }}:
                              <currency :code="row.currency"></currency>
                              {{ row.payAmount }}
                            </span>
                            <span v-if="row.ignoreAmount > 0" class="mgr5">
                              {{ $t("bargain.ignore") }}:
                              <currency :code="row.currency"></currency>
                              {{ row.ignoreAmount }}
                            </span>
                            <span v-if="row.differAmount > 0" class="red mgr5">
                              {{ $t("bargain.differ") }}:
                              <currency :code="row.currency"></currency>
                              {{ row.differAmount }}
                            </span>
                            <span
                              v-if="row.differAmount == 0"
                              class="green mgr5"
                              >{{ $t("bargain.settled") }}</span
                            >
                            <span v-if="row.differAmount < 0" class="orange">
                              {{ $t("bargain.leave") }}:
                              <currency :code="row.currency"></currency>
                              {{ row.differAmount * -1 }}
                            </span>
                          </span>
                        </span>
                      </span>
                      <div
                        v-if="row.financeAudit != null"
                        class="font12 float-left"
                      >
                        <el-popover
                          placement="right"
                          width="300"
                          trigger="click"
                        >
                          <div>
                            <div class="lineH24">
                              {{ $t("verify.commentName") }}:
                              {{ row.financeAudit.commentName }}
                            </div>
                            <div class="lineH24">
                              {{ $t("verify.commentAt") }}:
                              {{ row.financeAudit.commentAt }}
                            </div>
                            <div
                              v-if="row.financeAudit.dealType == 'reject'"
                              class="lineH24"
                            >
                              {{ $t("verify.comment") }}:
                              {{ row.financeAudit.comment }}
                            </div>
                          </div>
                          <span
                            slot="reference"
                            class="popover-reference"
                            :class="
                              row.financeAudit.dealType == 'agree'
                                ? 'green-shallow'
                                : 'red'
                            "
                            >{{ $t("action.verify") }}({{
                              $t(
                                "verifyTypesSimple." + row.financeAudit.dealType
                              )
                            }})</span
                          >
                        </el-popover>
                      </div>

                      <span class="float-right font10">
                        {{ $t("menu.customers") }}:
                        <span
                          v-if="
                            row.replaceCustomerId != null &&
                            row.customer != null
                          "
                          >{{ row.customer.name }}</span
                        >
                        <span v-if="row.replaceCustomerId == null">{{
                          row.customerName
                        }}</span>
                        <span
                          v-if="
                            row.customer != null && row.customer.type != null
                          "
                          >({{
                            $t("customerTypes." + row.customer.type)
                          }})</span
                        >
                        {{ $t("text.owner") }}:{{ row.ownerName }}
                        {{ row.shopName }}
                      </span>
                    </div>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="serialNo"
                  :title="$t('text.serialNo')"
                  min-width="120"
                >
                  <template v-slot="{ row }">
                    <small v-if="row.hurry" class="red"
                      >({{ $t("order.hurrySimple") }})</small
                    >
                    <span class="font10">
                      <s v-if="row.workflowState == 'canceled'" class="grey">{{
                        row.serialNo
                      }}</s>
                      <span v-else>{{ row.serialNo }}</span>
                    </span>
                    <div class="font10">{{ row.innerSerialNo }}</div>
                    <div>
                      <state-label
                        :state="row.workflowState"
                        :permit="Permit.canActions('orderDealView')"
                      >
                        <span v-if="Permit.canActions('orderDealView')">{{
                          $t("orderStates." + row.workflowState)
                        }}</span>
                        <span v-else>{{
                          $t("orderStatesNoPermit." + row.workflowState)
                        }}</span>
                      </state-label>
                    </div>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="handOverAt"
                  :title="$t('text.handOverAt')"
                  min-width="120"
                >
                  <template v-slot="{ row }">
                    {{ row.handOverAt }}
                    <div v-if="row.confirmAt != null" class="font10 green">
                      {{ $t("order.confirm") }}:{{ row.confirmAt }}
                    </div>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="productNo"
                  :title="$t('product.productNo')"
                  min-width="100"
                >
                  <template v-slot="{ row }">
                    {{ row.productNo }}
                    <small
                      v-if="
                        row.customerProductNo != null &&
                        row.customerProductNo != ''
                      "
                      >({{ row.customerProductNo }})</small
                    >

                    <div class="font10">
                      {{ row.categoryName }}
                      <span v-if="row.productBrand != null">/</span>
                      {{ row.productBrand }}
                    </div>
                    <div class="font10">{{ row.color }} {{ row.size }}</div>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  v-if="Permit.canActions('globalSalePrice')"
                  field="price"
                  :title="$t('order.price')"
                  min-width="80"
                >
                  <template v-slot="{ row }">
                    <currency :code="row.currency"></currency>
                    {{ row.price }}
                    <small
                      v-if="row.discountRate != null && row.discountRate != 0"
                      >({{ row.discountRate }}%)</small
                    >
                    <div
                      v-if="row.extraCharge != null && row.extraCharge != 0"
                      class="font10"
                    >
                      {{ $t("order.extraChargeSimple") }}:
                      <currency :code="row.currency"></currency>
                      {{ row.extraCharge }}
                    </div>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="quantity"
                  :title="$t('text.quantity')"
                  min-width="80"
                >
                  <template v-slot="{ row }">
                    {{ row.quantity }}{{ row.unit || "" }}
                    <div class="font10">
                      {{ $t("order.complete") }}: {{ row.dealQuantity
                      }}{{ row.unit || "" }}
                      <small v-if="row.orderReceives != null">
                        ({{
                          row.orderReceives.map((r) => r.shopName).join(",")
                        }})
                      </small>
                    </div>
                    <div class="font10">
                      <el-popover
                        placement="right"
                        width="600"
                        trigger="click"
                        @show="getDeliveries(row)"
                      >
                        <vxe-table
                          :data="deliveries"
                          id="deliverInfosTable"
                          row-id="id"
                          ref="deliverInfosTable"
                          class="recordsTable"
                          size="mini"
                          resizable
                          round
                          auto-resize
                          highlight-hover-row
                          :scroll-y="{ enabled: false }"
                        >
                          <vxe-table-column
                            field="deliverType"
                            :title="$t('delivery.deliveryMethode')"
                          >
                            <template v-slot="{ row }">
                              <span v-if="row.deliverType != null">{{
                                $t("deliverTypes." + row.deliverType)
                              }}</span>
                            </template>
                          </vxe-table-column>
                          <vxe-table-column
                            field="express"
                            :title="$t('delivery.express')"
                          />
                          <vxe-table-column
                            field="deliverMethodName"
                            :title="$t('delivery.channel')"
                          />
                          <vxe-table-column
                            field="tracking"
                            :title="$t('delivery.tracking')"
                          />
                          <vxe-table-column
                            field="attachment"
                            :title="$t('product.attachment')"
                          >
                            <template v-slot="{ row }">
                              <thumbnail-text
                                :srcs="row.attachment"
                                :text="'附件'"
                              />
                            </template>
                          </vxe-table-column>
                          <vxe-table-column
                            field="deliverBy"
                            :title="$t('delivery.deliverBy')"
                          />
                          <vxe-table-column
                            field="deliverAt"
                            :title="$t('delivery.deliverAt')"
                          />
                        </vxe-table>
                        <span slot="reference" class="popover-reference">
                          {{ $t("order.delivered") }}:{{ row.deliveredQuantity
                          }}{{ row.unit || "" }}
                        </span>
                      </el-popover>
                    </div>

                    <div
                      v-if="row.deliveryRequisitionQuantity > 0"
                      class="font10"
                    >
                      <el-popover
                        placement="right"
                        width="600"
                        trigger="click"
                        @show="getDeliveryRequisitions(row)"
                      >
                        <vxe-table
                          :data="deliveryRequisitionInfos"
                          id="deliveryRequisitionInfosTable"
                          row-id="id"
                          ref="deliveryRequisitionInfosTable"
                          class="recordsTable"
                          size="mini"
                          resizable
                          round
                          auto-resize
                          highlight-hover-row
                          :scroll-y="{ enabled: false }"
                        >
                          <vxe-table-column
                            field="serialNo"
                            :title="$t('deliveryRequisition.serialNo')"
                          />

                          <vxe-table-column
                            field="applyName"
                            :title="$t('deliveryRequisition.applyName')"
                          />
                          <vxe-table-column
                            field="quantity"
                            :title="$t('deliveryRequisition.quantity')"
                          >
                            <template v-slot="{ row }">
                              <span
                                v-if="
                                  row.deliveryRequisitionItems &&
                                  row.deliveryRequisitionItems.length != 0
                                "
                              >
                                {{ row.deliveryRequisitionItems[0].quantity }}
                                <raw-html-limit-number
                                  :content="
                                    row.deliveryRequisitionItems[0].remark
                                  "
                                  :number="10"
                                />
                              </span>
                            </template>
                          </vxe-table-column>
                          <vxe-table-column
                            field="handOverAt"
                            :title="$t('deliveryRequisition.handOverAt')"
                          />
                          <vxe-table-column
                            field="remark"
                            :title="$t('text.remark')"
                          >
                            <template v-slot="{ row }">
                              <raw-html-limit-number
                                :content="row.remark"
                                :number="10"
                              />
                            </template>
                          </vxe-table-column>
                          <vxe-table-column
                            field="createAt"
                            :title="$t('text.createAt')"
                          />
                        </vxe-table>
                        <span slot="reference" class="popover-reference">
                          发货申请数量:{{ row.deliveryRequisitionQuantity
                          }}{{ row.unit || "" }}
                        </span>
                      </el-popover>
                    </div>
                  </template>
                </vxe-table-column>

                <vxe-table-column
                  field="deliverQuantity"
                  :title="$t('deliveryRequisition.quantity')"
                  min-width="80"
                >
                  <template v-slot="{ row }">
                    <el-input
                      v-model.trim="row.deliverQuantity"
                      size="small"
                      :max="row._maxDeliverQuantity"
                      :placeholder="row._maxDeliverQuantity"
                    />
                  </template>
                </vxe-table-column>

                <vxe-table-column
                  field="dealType"
                  :title="$t('order.dealType')"
                  min-width="80"
                >
                  <template v-slot="{ row }">
                    <span v-if="row.dealType !== null">
                      {{ $t("dealTypes." + row.dealType) }}
                    </span>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="createAt"
                  :title="$t('text.createAt')"
                  min-width="110"
                />
                <vxe-table-column
                  field="remark"
                  :title="$t('text.remark')"
                  min-width="60"
                >
                  <template v-slot="{ row, rowIndex }">
                    <raw-html-limit-number
                      :content="row.remark"
                      :number="10"
                      type="richText"
                    />
                    <div class="orange font10">
                      <i
                        slot="reference"
                        class="el-icon-edit"
                        @click="editDeliverRemark(row, rowIndex)"
                      />
                      <raw-html-limit-number
                        :content="row.deliverRemark"
                        :number="10"
                      />
                    </div>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="action"
                  :title="$t('text.action')"
                  width="50"
                >
                  <template v-slot="{ row, rowIndex }">
                    <template v-if="row.isBargain">
                      <el-button
                        type="text"
                        size="mini"
                        @click="removeBargain(row, rowIndex)"
                        >{{ $t("text.remove") }}</el-button
                      >
                    </template>
                    <template v-else>
                      <el-button
                        type="text"
                        size="mini"
                        @click="removeOrder(row, rowIndex)"
                        >{{ $t("text.remove") }}</el-button
                      >
                    </template>
                  </template>
                </vxe-table-column>
              </vxe-table>
            </fieldset>
          </div>
          <div class="form-footer">
            <el-button
              type="primary"
              size="medium"
              plain
              :loading="saveDoing"
              @click="saveSubmit"
              >{{ $t("text.submit") }}</el-button
            >
            <back-button />
          </div>
        </el-form>
      </div>

      <el-dialog
        :title="$t('rules.edit', [$t('text.remark')])"
        :close-on-click-modal="false"
        :visible.sync="editDeliveryRemarkDF"
        width="30%"
      >
        <el-form>
          <el-input
            size="small"
            v-model.trim="editDeliveryRemarkObj.deliveryRemark"
            type="textarea"
            :placeholder="$t('text.remark')"
          />
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            plain
            :loading="editDeliveryRemarkDoing"
            size="small"
            @click="editDeliveryRemarkSubmit"
            >{{ $t("text.submit") }}</el-button
          >
          <el-button size="small" @click="editDeliveryRemarkDF = false">{{
            $t("text.close")
          }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { page } from "@/utils/mixins.js";
import Util from "@/utils";
import BackButton from "@/components/BackButton";
import Currency from "@/components/Currency";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import Narrow from "@/components/Narrow";
import Thumbnail from "@/components/Thumbnail";
import Bargain from "@/api/bargain.js";
import DeliveryRequisition from "@/api/deliveryRequisition.js";
import Delivery from "@/api/delivery.js";
import Order from "@/api/order.js";

export default {
  mixins: [page],
  components: { BackButton, Currency, RawHtmlLimitNumber, Thumbnail, Narrow },
  data() {
    var validateSerialNo = (rule, value, callback) => {
      const self = this;
      if (value === null || value.trim() === "") {
        callback(
          new Error(this.$t("rules.required", [this.$t("bargain.serialNo")]))
        );
        return;
      }
      if (!Util.regexAlphabetNumberLine(value)) {
        callback(new Error(this.$t("prompt.regexAlphabetNumberLine")));
        return;
      }
      DeliveryRequisition.findBySerialNo({ serialNo: value }).then(function (
        res
      ) {
        if (res.status === 200 && res.data.length !== 0) {
          callback(
            new Error(
              self.$t("rules.exist", [self.$t("deliveryRequisition.serialNo")])
            )
          );
        } else {
          callback();
        }
      });
    };
    return {
      validateSerialNo: validateSerialNo,
      pickerTodayAfterTime: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      Util: Util,
      radioType: "finished",
      //
      bargains: [],
      deliveryRequisitionObj: {
        serialNo: null,
        handOverAt: null,
        remark: null,
      },
      computeBargains: [],
      mergeCells: [],
      saveDoing: false,
      //
      deliveries: [],
      deliveryRequisitionInfos: [],
      //编辑备注
      editDeliveryRemarkDF: false,
      row: null,
      rowIndex: null,
      editDeliveryRemarkDoing: false,
      editDeliveryRemarkObj: {
        deliveryRemark: null,
      },
      narrows: [],
      initOrderWorkflowStates: [
        "preparing",
        "prepared",
        "processing",
        "processed",
        "purchasing",
        "purchased",
        "partially",
      ],
    };
  },
  mounted() {},
  created() {
    const self = this;
    self.loadingStart();
    const bargainIds =
      typeof self.$route.query.bargainIds == "string"
        ? [self.$route.query.bargainIds]
        : self.$route.query.bargainIds;
    self.deliveryRequisitionObj.serialNo = Util.serialNo();
    self.deliveryRequisitionObj.handOverAt = new Date();
    Bargain.findWithOrdersByIds(bargainIds).then(function (res) {
      self.loadingEnd();
      if (res.status === 200) {
        self.bargains = res.data;
        self.selectRadioType();
      } else {
        self.sysError();
      }
    });
  },

  methods: {
    selectRadioType() {
      const self = this;
      let narrowOrderWorkflowStates = [];
      if (self.radioType == "finished") {
        narrowOrderWorkflowStates = [
          "prepared",
          "processed",
          "purchased",
          "partially",
        ];
      } else {
        narrowOrderWorkflowStates = self.initOrderWorkflowStates;
      }
      let oldBargain = JSON.parse(JSON.stringify(self.bargains));
      for (const bargain of oldBargain) {
        if (bargain.orders.length !== 0) {
          for (const order of bargain.orders) {
            Vue.set(
              order,
              "deliverQuantity",
              order.quantity -
                order.deliveredQuantity -
                order.deliveryRequisitionQuantity
            );
            Vue.set(
              order,
              "_maxDeliverQuantity",
              order.quantity -
                order.deliveredQuantity -
                order.deliveryRequisitionQuantity
            );
            Vue.set(order, "deliverRemark", order.remark);
          }
          Vue.set(
            bargain,
            "ordersfilter",
            bargain.orders.filter(
              (o) =>
                narrowOrderWorkflowStates.includes(o.workflowState) &&
                o._maxDeliverQuantity > 0
            )
          );
        }
      }
      let newBargains = oldBargain.filter((b) => b.ordersfilter.length !== 0);
      self.computeBargains = self.buildTableData(newBargains);
      self.mergeCells = self.buildMergeCells(newBargains);
    },
    //
    editDeliverRemark(row, rowIndex) {
      this.row = row;
      this.rowIndex = rowIndex;
      this.editDeliveryRemarkObj.deliveryRemark = row.deliverRemark;
      this.editDeliveryRemarkDoing = false;
      this.editDeliveryRemarkDF = true;
    },

    editDeliveryRemarkSubmit() {
      const self = this;
      self.editDeliveryRemarkDoing = true;
      self.computeBargains[self.rowIndex].deliverRemark =
        this.editDeliveryRemarkObj.deliveryRemark;
      self.editDeliveryRemarkDoing = false;
      self.editDeliveryRemarkDF = false;
      self.$message({
        message: self.$t("prompt.editSuccess"),
        type: "success",
      });
    },

    //
    getDeliveryRequisitions(row) {
      const self = this;
      DeliveryRequisition.findByOrderSerialNo({
        orderSerialNo: row.serialNo,
        deliveryRequisition: "unDeal",
      }).then(function (res) {
        if (res.status === 200) {
          self.deliveryRequisitionInfos = res.data;
        } else {
          self.sysError();
        }
      });
    },
    //
    // 获取发货信息
    getDeliveries(row) {
      const self = this;
      Delivery.findByOrderUuid(row.uuid).then(function (res) {
        if (res.status == 200) {
          self.deliveries = res.data;
        } else {
          self.sysError();
        }
      });
    },
    removeBargain(row, rowIndex) {
      const self = this;
      for (const bargainIndex in self.bargains) {
        if (self.bargains[bargainIndex].id == row.id) {
          self.bargains.splice(bargainIndex, 1);
        }
      }
      self.selectRadioType();
    },
    removeOrder(row, rowIndex) {
      const self = this;
      for (const bargainIndex in self.bargains) {
        const orderIndex = self.bargains[bargainIndex].orders.findIndex(
          (o) => o.id == row.id
        );
        if (orderIndex != -1) {
          self.bargains[bargainIndex].orders.splice(orderIndex, 1);
        }
        if (self.bargains[bargainIndex].orders.length == 0) {
          self.bargains.splice(bargainIndex, 1);
        }
      }
      self.selectRadioType();
    },
    saveSubmit() {
      const self = this;
      this.$refs.deliveryRequisitionObjForm.validate((valid) => {
        if (valid) {
          if (self.computeBargains.length === 0) {
            self.$message.error(this.$t("prompt.atLeastOneData"));
            return;
          }
          let orders = self.computeBargains.filter(
            (record) => !record.isBargain
          );
          const deliveryRequisitionItems = [];
          for (let order of orders) {
            let canNotWorkflowStates = ["finished", "returned", "canceled"];
            if (canNotWorkflowStates.includes(order.workflowState)) {
              self.$message({
                message:
                  "交货完成、客户退货、客户取消状态的订单项不能生成发货申请单",
                type: "warning",
              });
              return;
            }
            if (
              !Util.regexQuantity(order.deliverQuantity) ||
              order.deliverQuantity === 0 ||
              order.deliverQuantity === "0"
            ) {
              self.$message({
                message: self.$t("rules.regex", [self.$t("text.quantity")]),
                type: "warning",
              });
              return;
            }
            if (order.deliverQuantity > order._maxDeliverQuantity) {
              self.$message({
                message: self.$t("prompt.deliveredQuantityBeyond"),
                type: "warning",
              });
              return;
            }
            deliveryRequisitionItems.push({
              bargainId: order.bargainId,
              orderId: order.id,
              quantity: order.deliverQuantity,
              remark: order.deliverRemark,
            });
          }
          const data = {
            serialNo: self.deliveryRequisitionObj.serialNo,
            handOverAt: Util.formatDate(self.deliveryRequisitionObj.handOverAt),
            remark: self.deliveryRequisitionObj.remark,
            customerId: self.bargains[0].customerId,
            customerName: self.bargains[0].customerName,
            deliveryRequisitionItems: deliveryRequisitionItems,
          };
          self.saveDoing = true;
          DeliveryRequisition.create(data).then(function (res) {
            self.saveDoing = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.$eventHub.$emit("deliveryRequisitionCreate");
              self.$router.push({ name: "omsBargains" });
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    //
    buildTableData(records) {
      let rs = [];
      records.forEach((record) => {
        let bOrder = {
          isBargain: true,
          id: record.id,
          uuid: record.uuid,
          serialNo: record.serialNo,
          shopId: record.shopId,
          shopName: record.shopName,
          settleType: record.settleType,
          amount: record.amount,
          currency: record.currency,
          customerId: record.customerId,
          customerName: record.customerName,
          customerCountry: record.customerCountry,
          customerProvince: record.customerProvince,
          customerCity: record.customerCity,
          customerAddress: record.customerAddress,
          customerPhone: record.customerPhone,
          customerZipcode: record.customerZipcode,
          customerType: record.customerType,
          customerSource: record.customerSource,
          customerEmail: record.customerEmail,
          deliveryRemark: record.deliveryRemark,
          groupJson: record.groupJson,
          remark: record.remark,
          ownerId: record.ownerId,
          ownerName: record.ownerName,
          createAt: record.createAt,
          plateform: record.plateform,
          plateformBargainId: record.plateformBargainId,
          cnyAmount: record.cnyAmount,
          replaceCustomerId: record.replaceCustomerId,
          lastDealtAt: record.lastDealtAt,
          customer: record.customer,
          productAmount: record.productAmount,
          // currentMonthAmount: record.currentMonthAmount,
          plateformStoreId: record.plateformStoreId,
          financeDeliveryAt: record.financeDeliveryAt,
          deliveryAudit: record.deliveryAudit,
          financeAudit: record.financeAudit,
          payAmount: record.payAmount,
          productQty: record.productQty,
          differAmount: record.differAmount,
          ignoreAmount: record.ignoreAmount,
          orders: record.orders,
        };
        rs.push(bOrder); //将bargain的数据转换到格式，放到数据列表
        record.ordersfilter.forEach((order) => {
          rs.push(order);
        });
      });
      return rs;
    },
    buildMergeCells(bargains) {
      let mcs = [];
      for (let i = 0, rowIdx = 0; i < bargains.length; i++) {
        if (this.Permit.canActions("globalSalePrice")) {
          mcs.push({ row: rowIdx, col: 0, rowspan: 1, colspan: 10 });
        } else {
          mcs.push({ row: rowIdx, col: 0, rowspan: 1, colspan: 9 });
        }
        rowIdx = rowIdx + bargains[i].ordersfilter.length + 1;
      }
      return mcs;
    },
    calculateBgColor({ row, rowIndex }) {
      return row.isBargain ? "light-blue-bg" : "";
    },
  },
};
</script>
<style lang="scss" scoped>
.name {
  text-overflow: ellipsis;
  overflow: hidden;
}
.addr {
  font-size: 12px;
  color: #b4b4b4;
}
</style>